// extracted by mini-css-extract-plugin
module.exports = {"section":"N_section__xxNV_","space1":"N_space1__ErTdr","space2":"N_space2__hTChy"};